<div class="delivery-mentor-dropouts-view-part">
	<mentor-dropouts-grid-part parent='delivery' [service]="pageService" [rows]="mentorDropouts()"></mentor-dropouts-grid-part>
</div>